export default "__VITE_ASSET__574a358e__"